import { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { channelBuyQuery, mobileBrandQuery } from '../../../services/react-query/optionMasterQuery';
import { useInsertWarranty } from './useInsertWarranty';
import { useGetRegisterList } from '../../registration/hooks/useGetRegisterList';
import { handleSubmitForm } from '../function/submitHandler';

const defaultMobileRow = () => ({ mobileBrandId: undefined, mobileModelName: '' });

export const useGetRegProductList = () => {
  const profile = useSelector((state) => state.info) || null;
  const fullName = profile ? profile.fullName : '-';
  const telephone = profile ? profile.telephone : '-';
  const { getValues, setValue, control, handleSubmit } = useForm({
    defaultValues: {
      fullName: '',
      telephone: '',
      barcodeShortcut: '',
      productTypeName: '',
      mobiles: [defaultMobileRow()],
    },
  });

  const { fields: mobileFields, append: appendMobile, remove: removeMobile } = useFieldArray({
    control,
    name: 'mobiles',
  });
  const { isLoadingBarcode } = useGetRegisterList();
  const { data: mobileBrandList } = mobileBrandQuery();
  const { data: channelBuyList } = channelBuyQuery();
  const { mutate: onInsertWarranty } = useInsertWarranty();

  useEffect(() => {
    setValue('fullName', fullName);
    setValue('telephone', telephone);
  }, [fullName, telephone, setValue]);

  const onSubmit = async (values) => {
    try {
      await handleSubmitForm(values, onInsertWarranty);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const canAddMobileRow = mobileFields.length < 3;
  const canRemoveMobileRow = mobileFields.length > 1;

  const onAddMobileRow = () => {
    if (!canAddMobileRow) return;
    appendMobile(defaultMobileRow());
  };

  const onRemoveMobileRow = (index) => {
    if (!canRemoveMobileRow) return;
    removeMobile(index);
  };

  return {
    getValues,
    setValue,
    control,
    mobileBrandList,
    channelBuyList,
    onSubmit,
    handleSubmit,
    isLoadingBarcode,
    mobileFields,
    canAddMobileRow,
    canRemoveMobileRow,
    onAddMobileRow,
    onRemoveMobileRow,
  };
};
